<nb-card style="width:950px">
  <nb-card-header>
    <div i18n="@@Items" class="title">Items</div>
  </nb-card-header>


  <nb-card-body [formGroup]="MealForm">
    <div class="form-group">

      <table>
        <tr>
          <td>
            <div class="col-sm-1 label col-form-label">{{MealNameLabel}}</div>
          </td>
          <td>
            <div>
              <input nbInput formControlName="MealName" style="width:150px"
                [status]="(MealName?.hasError('minlength') || MealName?.hasError('maxlength')) ? 'danger' : 'primary'"
                type="text" fullWidth shape="semi-round" placeholder="{{MealNameLabel}}">
            </div>
          </td>
          <td>
            <div class="label col-form-label">{{MealTimeLabel}}</div>
          </td>
          <td>
            <div>
              <!-- <ngx-timepicker-field [controlOnly]="true" formControlName="MealTime" [defaultTime]="'11:11 am'">
              </ngx-timepicker-field> -->

              <ngx-validation-message label={{MealTimeLabel}}
                [showRequired]="MealTime?.errors?.required && MealTime.touched">
              </ngx-validation-message>
            </div>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
            <ngx-validation-message label={{MealNameLabel}} [showMinLength]="MealName?.hasError('minlength')"
              [showMaxLength]="MealName?.hasError('maxlength')"
              [showRequired]="MealName?.errors?.required && MealName .touched" minLength=3 maxLength=25>
            </ngx-validation-message>
          </td>
        </tr>
      </table>

      <nb-card style="height:500px;">
        <nb-card-body style="padding: 0;">
          <ng2-smart-table class="order-smart-table" [source]="MealDataSource" [settings]="MealTableSettings"
            (delete)="onDelete($event)">
          </ng2-smart-table>
        </nb-card-body>
      </nb-card>

    </div>
  </nb-card-body>


  <nb-card-footer>
    <table>
      <tr>
        <td><button i18n="@@Accept" nbButton type="submit"  (click)="Accept()" class="btn-circle btn-xl btn-main btn-circle btn-xl"
            [disabled]="!MealValid">Accept</button></td>
        <td><button i18n="@@Back" nbButton class="btn-circle btn-xl btn-main btn-circle btn-xl" status="info" (click)="Back()">Back</button></td>
        <td><button i18n="@@AddItem" nbButton class="btn-circle btn-xl btn-main btn-circle btn-xl" status="info" (click)="SelectItems()">Add
            Item</button></td>
      </tr>
    </table>
  </nb-card-footer>
</nb-card>
